// import React, { useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
// } from '@mui/material';
// import { Formik, Form } from 'formik';
// import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// import '../../ContentManagement/Home/Modal/BannerinputGetModal.css'// Import external CSS
// import { MdCancel } from "react-icons/md";
// import * as Yup from 'yup';
// import CustoDropDownRegister from '../../../Components/CustomDropDown/CustoDropDownRegister';
// import CustomDropdownDocumentType from '../../../Components/CustomDropDown/CustomDropdownDocumentType';
// import FileUploadForCreateUser from '../../../Components/FileUploadComponent/FileUploadForCreateUser';
// import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"

// const SchemeCreateModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName }) => {
//     // const [uploadedFile, setUploadedFile] = useState(null);
//     const [uploadedFiles, setUploadedFiles] = useState([])
//     const [selectedDocumentType, setSelectedDocumentType] = React.useState('');

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 // maxWidth: "700px",
//                 // margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">

//                         <Box>
//                             <Typography className="custom-title-text" color='white'>
//                                 Scheme Create
//                             </Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>

//                 <Formik
//                     initialValues={{
//                         first_name: '',

//                         user_type: '',
//                         emiratesid: "",
//                         email: "",
//                         mobile_number: "",
//                         Address_line_1: "",
//                         Address_line_2: "",
//                         city: "",
//                         state: "",
//                         country: "",
//                         zipcode: "",

//                         image_url: [],
//                     }}
//                     validationSchema={Yup.object({
//                         emiratesid: Yup.string().required('Emirates Id is required'),
//                         // subtitle: Yup.string().required('Subtitle is required'),
//                         first_name: Yup.string().required('first Name is required'),
//                         last_name: Yup.string().required('Last Name is required'),
//                         user_type: Yup.string().required('User Type is required'),
//                         email: Yup.string().required('Email is required'),
//                         mobile_number: Yup.string().required('Mobile Number is required'),
//                         Address_line_1: Yup.string().required('Address Line 1 is required'),
//                         Address_line_2: Yup.string().required('Address Line 2 is required'),

//                         city: Yup.string().required('city is required'),
//                         state: Yup.string().required('state is required'),

//                         country: Yup.string().required('Country is required'),
//                         zipcode: Yup.string().required('Zipcode Button Text is required'),
//                     })}
//                     onSubmit={(values, { resetForm }) => {
//                         // setSubmittedValues([...submittedValues, values]);
//                         console.log(values, "values")
//                         resetForm();

//                     }}
//                 >
//                     {({ handleSubmit, setFieldValue, resetForm, values }) => (
//                         <Form onSubmit={handleSubmit}>
//                             <DialogContent dividers>
//                                 <Grid container spacing={2}>
//                                     {/* Title and Subtitle on the left, Content on the right */}
//                                     <Grid item xs={12} md={12}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="First Name"
//                                                     name="first_name"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter First Name"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Last Name"
//                                                     name="last_name"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Last Name"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustoDropDownRegister
//                                                     important={true}

//                                                     name="user_type"
//                                                     label="User Type"
//                                                     custPlaceholder="select a type"
//                                                     options={[
//                                                         { label: "individual", value: "individual" },
//                                                         { label: "institutional", value: "institutional" },
//                                                     ]}
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Email"
//                                                     name="email"
//                                                     inputType="email"
//                                                     custPlaceholder="Enter Email"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Mobile Number"
//                                                     name="mobile_number"
//                                                     inputType="number"
//                                                     custPlaceholder="Enter Mobile Number"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Address Line 1"
//                                                     name="Address_line_1"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Address Line 1"
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12} md={4}>

//                                                 <CustomInputLogin
//                                                     label="Address Line 2"
//                                                     name="Address_line_2"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Address Line 2"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="City"
//                                                     name="city"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter City"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>

//                                                 <CustomInputLogin
//                                                     label="State"
//                                                     name="state"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter State"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>

//                                                 <CustomInputLogin
//                                                     label="Country"
//                                                     name="country"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Country"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>

//                                                 <CustomInputLogin
//                                                     label="Zipcode"
//                                                     name="zipcode"
//                                                     inputType="number"
//                                                     custPlaceholder="Enter ZipCode"
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12} md={4}>

//                                                 <CustomDropdownDocumentType
//                                                     name="emiratesid"
//                                                     label="Document Type"
//                                                     custPlaceholder="select a type"
//                                                     setFieldValue={setFieldValue}
//                                                     selectedDocumentType={selectedDocumentType}
//                                                     setSelectedDocumentType={setSelectedDocumentType}

//                                                     options={[
//                                                         { label: "Abhu Dhabi", value: "Abhu Dhabi" },
//                                                         { label: "Tamil Nadu", value: "Tamil Nadu" },
//                                                     ]}
//                                                 />

//                                             </Grid>

//                                             <Grid item xs={12} md={4}>
//                                                 {/* <FileUploadForCreateUser name="image_url" uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} onFileUpload={(file) => setFieldValue('image_url', file)}
//                                                     selectedDocumentType={selectedDocumentType}
//                                                 /> */}

//                                                 {/* <FileUploadForCreateUser
//                                                     name="fileUpload"
//                                                     // onFileUpload={handleFileUpload}
//                                                     uploadedFiles={uploadedFile}
//                                                     setUploadedFiles={setUploadedFile}
//                                                     selectedDocumentType={selectedDocumentType}

//                                                 /> */}
//                                                 <FileUploadForCreateUser
//                                                     name="image_url"
//                                                     onFileUpload={(file) => console.log("Uploaded file:", file)}
//                                                     uploadedFiles={uploadedFiles}
//                                                     setUploadedFiles={setUploadedFiles}
//                                                     selectedDocumentType={selectedDocumentType}
//                                                 />

//                                             </Grid>

//                                         </Grid>

//                                     </Grid>

//                                 </Grid>

//                                 {/* Action Buttons */}
//                                 {/* <DialogActions> */}
//                                 <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
//                                     <Grid>
//                                         <Button
//                                             onClick={() => {
//                                                 resetForm()
//                                                 setUploadedFiles(null)
//                                             }}
//                                             variant="text"
//                                             // className="custom-clear-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 mr: "10px",
//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "white",
//                                                 boxShadow: "none",
//                                                 color: "black",
//                                                 border: "1px solid black",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     color: "white"
//                                                 },
//                                             }}
//                                         >
//                                             Cancel
//                                         </Button>
//                                         <Button
//                                             type="submit"
//                                             variant="contained"
//                                             // className="custom-ok-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 boxShadow: "none",

//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "#C38F51 0% 0% no-repeat padding-box",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     boxShadow: "none",

//                                                 },
//                                             }}
//                                         >
//                                             Submit
//                                         </Button>
//                                     </Grid>
//                                 </Grid>

//                             </DialogContent>

//                             {/* </DialogActions> */}
//                         </Form>
//                     )
//                     }
//                 </Formik >

//             </Box >
//         </Dialog >
//     );
// };

// export default SchemeCreateModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
  Typography,
  Grid,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Formik, Form } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";

import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import '../../../Home/Modal/BannerinputGetModal.css'; // Import external CSS
// import "../../ContentManagement/Home/Modal/BannerinputGetModal.css";

import "../../ContentManagement/Home/Modal/BannerinputGetModal.css";

import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import { FiUpload } from "react-icons/fi";
import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomInputGoldValueInput from "../../../Components/CustomInputLogin/CustomInputGoldValueInput";
import CustomDisableGoldInput from "../../../Components/CustomInputLogin/CustomDisableGoldInput";
import actions from "../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import WarningModal from "./WarningModal";
import { format } from "date-fns";
import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";

const SchemeCreateModal = ({
  open,
  onClose,
  setSubmittedValues,
  submittedValues,
  // editData
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);

  const [grams, setGrams] = useState(0);
  const dispatch = useDispatch();

  const TableId = useSelector((state) => state.Table.TableId);
  console.log(TableId, "tableIddddddd")
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);

  const { getPlanById } = useSelector((state) => state?.getPlanById);
  const [editData, setEditData] = useState([])
  console.log(editData, "editDatattatattatata")

  useEffect(() => {
    if (!open) return; // Only fetch when modal is open

    console.log("itssssssss")
    if (TableId) {
      const fetchData = async () => {
        try {

          const data1 = {
            data: {},
            method: "get",
            apiName: `getPlanById/${TableId}`,
          };
          const responseData = await dispatch(actions.GETPLANBYID(data1));
          setEditData(responseData)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      fetchData();
    }

  }, [dispatch, open]);


  const hadleWarningModalOpen = () => {
    setWarningModalOpen(true);
  };

  const hadleWarningModalClose = () => {
    setWarningModalOpen(false);
  };

  const handleSubmit = async (values, resetForm) => {
    // const data1 = {
    //   data: values,
    //   method: "post",
    //   apiName: "addPlan",
    // };

    // const responseData = await dispatch(actions.ADDPLANPOST(data1));

    // if (responseData?.payload?.message === "Plan added successfully.") {
    hadleWarningModalOpen();
    //   resetForm();
    //   setGrams();
    // } 
  };



  const [formValues, setFormValues] = useState({
    first_name: "",
    type: "",
    email: "",
    isVerified: false,
    phone: "",
    password: "",
    confirmPassword: "",
    country: "",
    state: "",
    city: "",
    zip_code: "",
    address_1: "",
    address_2: "",
  });

  // useEffect(() => {
  //   if (editData) {
  //     setFormValues({
  //       title: editData?.payload?.data?.title || "",
  //       primary_button_text: editData?.payload?.data?.primary_button_text || "",
  //       secondary_button_text: editData?.payload?.data?.secondary_button_text || "",
  //       lock_in_months: editData?.payload?.data?.lock_in_months || "",
  //       maturity_in_months: editData?.payload?.data?.maturity_in_months || "",
  //       currency: editData?.payload?.data?.currency || "",
  //       status: editData?.payload?.data?.status || "active",
  //       closure_date:  format(new Date(editData?.payload?.data?.closure_date), 'MM/dd/yyyy')|| "",
  //       description: editData?.payload?.data?.description || "",
  //       reap_percentage: editData?.payload?.data?.reap_percentage || "",
  //       reap_months: editData?.payload?.data?.reap_months || "",
  //       value_of_purchase: editData?.payload?.data?.value_of_purchase || "",
  //       purchase_stake: editData?.payload?.data?.purchase_stake || "",
  //       image_url: editData?.payload?.data?.image_url || null,
  //     });
  //     // setUploadedFiles(editData.image)
  //   } else {
  //     setFormValues({
  //       title: "",

  //       primary_button_text: "",
  //       secondary_button_text: "",
  //       lock_in_months: "",
  //       maturity_in_months: "",
  //       currency: "",

  //       status: "active",
  //       closure_date: "",
  //       description: "",

  //       reap_percentage: "",
  //       reap_months: "",
  //       value_of_purchase: "",
  //       purchase_stake: "",

  //       image_url: null,
  //     });
  //   }
  // }, [editData, open]);

  useEffect(() => {
    if (editData?.payload?.data) {
      const closureDate = editData?.payload?.data?.closure_date
      // ? format(new Date(editData?.payload?.data?.closure_date), 'yyyy-MM-dd')
      // ? format(new Date(editData?.payload?.data?.closure_date), 'yyyy-MM-dd')

      // : null;
      console.log(closureDate, "closureDate")
      if (closureDate) {
        setFormValues({
          title: editData?.payload?.data?.title || "",
          primary_button_text: editData?.payload?.data?.primary_button_text || "",
          secondary_button_text: editData?.payload?.data?.secondary_button_text || "",
          lock_in_months: editData?.payload?.data?.lock_in_months || "",
          maturity_in_months: editData?.payload?.data?.maturity_in_months || "",
          currency: editData?.payload?.data?.currency || "",
          status: editData?.payload?.data?.status.toLowerCase() || "active",
          // closure_date: closureDate ? `${closureDate}` : null, // Check for a valid date
          closure_date: editData?.payload?.data?.closure_date
            ? new Date(editData.payload.data.closure_date).toISOString().split("T")[0]
            : "", // Check for a valid date

          description: editData?.payload?.data?.description || "",
          reap_percentage: editData?.payload?.data?.reap_percentage || "",
          reap_months: editData?.payload?.data?.reap_months || "",
          value_of_purchase: editData?.payload?.data?.value_of_purchase || "",
          purchase_stake: editData?.payload?.data?.purchase_stake || "",
          image_url: editData?.payload?.data?.image_url || null,
        });
      }
      setUploadedFile(
        {
          fileUrl: editData?.payload?.data?.image_url,
          // type: selectedDocumentType ? selectedDocumentType.type : file.type,
          type: "image",
          progress: 100,
        });
    } else {
      setFormValues({
        title: "",
        primary_button_text: "",
        secondary_button_text: "",
        lock_in_months: "",
        maturity_in_months: "",
        currency: "",
        status: "active",
        closure_date: "",
        description: "",
        reap_percentage: "",
        reap_months: "",
        value_of_purchase: "",
        purchase_stake: "",
        image_url: null,
      });
      setUploadedFile(null)
    }
  }, [editData, open]);


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        // maxWidth: "700px",
        // margin: "auto",
        "& .MuiPaper-root": {
          borderRadius: "14px", // Target the Paper component
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={() => {
              onClose()
              dispatch(clearTableGetId(null))
              dispatch(clearCustomerId(null))

            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text">
                {editData ? "Create Scheme" : "Edit Scheme"}
              </Typography>
            </Box>
          </DialogTitle>
        </Box>

        <Formik


          initialValues={formValues}
          // validationSchema={validationSchema}
          enableReinitialize
          // initialValues={{
          //   title: "",

          //   primary_button_text: "",
          //   secondary_button_text: "",
          //   lock_in_months: "",
          //   maturity_in_months: "",
          //   currency: "",

          //   status: "active",
          //   closure_date: "",
          //   description: "",

          //   reap_percentage: "",
          //   reap_months: "",
          //   value_of_purchase: "",
          //   purchase_stake: "",

          //   image_url: null,
          // }}
          validationSchema={Yup.object({
            title: Yup.string().required("Title is required"),
            // subtitle: Yup.string().required('Subtitle is required'),
            value_of_purchase: Yup.string().required(
              "Value of Purchase is required"
            ),
            maturity_in_months: Yup.string().required("Maturity is required"),
            lock_in_months: Yup.string().required("Lock In is required"),
            // closure_date: Yup.string().required("Closure Date is required"),
            description: Yup.string().required("Description is required"),
            // Purchase_Stake: Yup.string().required("Value of purchase is required"),
            reap_percentage: Yup.string().required("Reap percentage is required"),
            reap_months: Yup.string().required("Reap months is required"),
            // url: Yup.string().required("URL is required"),

            primary_button_text: Yup.string().required(
              "Primary Button Text is required"
            ),
            secondary_button_text: Yup.string().required(
              "Secondary Button Text is required"
            ),
          })}
          onSubmit={(values, { resetForm }) => {
            // setSubmittedValues([...submittedValues, values]);
            handleSubmit(values, resetForm);
            console.log(values, "values");
            // resetForm();
          }}
        >
          {({ handleSubmit, setFieldValue, resetForm, values }) => (
            <Form onSubmit={handleSubmit}>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {/* Title and Subtitle on the left, Content on the right */}
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Title"
                          name="title"
                          inputType="text"
                          custPlaceholder="Enter Title"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>

                        <CustomInputLogin
                          label="Stake Amount (USD)"
                          name="value_of_purchase"
                          inputType="number"
                          custPlaceholder="Enter Amount"
                        />
                        {/* <CustomInputGoldValueInput
                          label="Stake Amount"
                          name="purchase_stake"
                          grams={grams}
                          setGrams={setGrams}
                          value_of_purchase="value_of_purchase"
                          custPlaceholder="Enter amount"
                          setFieldValue={setFieldValue}
                          inputType="number"
                          currency={true}
                        /> */}
                      </Grid>

                      <Grid item xs={12} md={4}>
                        {/* <CustomDisableGoldInput
                          label="Purchase Stake (in grms)"
                          name="purchase_stake"
                          grams={grams}
                    
                        /> */}

                        <CustomInputLogin
                          label="Purchase Stake (In grms)"
                          name="purchase_stake"
                          inputType="number"
                          custPlaceholder="Enter Grams"
                        />
                        {/* <CustomDisableGoldInput
                          label="Purchase Stake (in grms)"
                          name="purchase_stake"
                          grams={formValues.purchase_stake}
                        /> */}
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Maturity (In months)"
                          name="maturity_in_months"
                          inputType="text"
                          custPlaceholder="Enter Maturity"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Lock In (In months)"
                          name="lock_in_months"
                          inputType="text"
                          custPlaceholder="Enter Lock In Months"
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <CustomInputLogin
                          label="Reap %"
                          name="reap_percentage"
                          inputType="text"
                          custPlaceholder="Enter Reap (In%)"
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <CustoDropDownRegister
                          //   important={true}
                          name="reap_months"
                          label="Reap Months"
                          custPlaceholder="Select Type"
                          options={[
                            { label: "3", value: "3" },
                            { label: "6", value: "6" },

                            { label: "9", value: "9" },

                            { label: "12", value: "12" },
                          ]}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomDateInput
                          label="Closure Date"
                          name="closure_date"
                          editData={editData?.payload?.data}

                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ActiveInactiveRadio
                          name="status"
                          value={values.status} // Ensure this is correctly passed from Formik
                          onChange={(value) => setFieldValue("status", value)} // Update the Formik state when the radio button changes
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Primary Button Text"
                          name="primary_button_text"
                          inputType="text"
                          custPlaceholder="Enter Primary Button Text"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Secondary Button Text"
                          name="secondary_button_text"
                          inputType="text"
                          custPlaceholder="Enter Secondary Button Text"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <FileUploadComponent
                          name="image_url"
                          uploadedFile={uploadedFile}
                          setUploadedFile={setUploadedFile}
                          onFileUpload={(file) =>
                            setFieldValue("image_url", file)
                          }
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <CustomInputLogin
                          label="Description"
                          name="description"
                          inputType="textarea"
                          custPlaceholder="Enter description"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={12} md={4}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FileUploadComponent
                          name="image_url"
                          uploadedFile={uploadedFile}
                          setUploadedFile={setUploadedFile}
                          onFileUpload={(file) => setFieldValue("image_url", file)}
                        />
                      </Grid>
                    </Grid>
                  </Grid> */}
                </Grid>

                {/* Action Buttons */}
                {/* <DialogActions> */}
                <Grid sx={{ display: "flex", justifyContent: "end", mt: 4 }}>
                  <Grid>
                    <Button
                      onClick={() => {
                        resetForm();
                        setUploadedFile(null);
                        onClose()
                        dispatch(clearTableGetId(null))
                        dispatch(clearCustomerId(null))


                      }}
                      variant="text"
                      // className="custom-clear-button"
                      sx={{
                        // backgroundColor: "#C38F51",
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        mr: "10px",
                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 40px" },

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "white",
                        boxShadow: "none",
                        color: "black",
                        border: "1px solid black",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                          color: "white",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      // className="custom-ok-button"
                      sx={{
                        // backgroundColor: "#C38F51",
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        boxShadow: "none",

                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 40px" },

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "#C38F51 0% 0% no-repeat padding-box",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                          boxShadow: "none",
                        },
                      }}
                    >
                      {TableId ? "Update" : "Submit"}
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>

              <WarningModal
                open={isWarningModalOpen}
                onClose={hadleWarningModalClose}
                editData={editData}
                resetForm={resetForm}
                setGrams={setGrams}
                handleSchemeModaClose={onClose}
                values={values}
              />

              {/* </DialogActions> */}
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default SchemeCreateModal;
